import { render, staticRenderFns } from "./FooterVacation.vue?vue&type=template&id=03277dda&scoped=true&"
import script from "./FooterVacation.vue?vue&type=script&lang=js&"
export * from "./FooterVacation.vue?vue&type=script&lang=js&"
import style0 from "./FooterVacation.vue?vue&type=style&index=0&id=03277dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03277dda",
  null
  
)

export default component.exports